import script from "./StoreItemInsuranceExportBlankCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreItemInsuranceExportBlankCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./StoreItemInsuranceExportBlankCardComponent.vue?vue&type=style&index=0&id=0b3c9248&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b3c9248"]])

export default __exports__